
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getEvaluateOrder, evaluateOrder } from '@/api/order';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'OrderEvaluate'
})
export default class extends Vue {
  private colors = ['#f7534f', '#f7534f', '#f7534f'];
  private formEvaluate = {};
  private orderTaskList: any = [];
  private evaluateTags:any=[];
  private orderId = '';
  private tags=[];
  private selectTags=[];
  created() {
    this.orderId = JSON.parse((this.$route.query.evaluateData as any)).order.id;
    this.getEvaluateOrder();
  }
  evaluateHandle() {
    this.evaluateOrder();
  }
  private rateChange(item: any) {
    item.selectTags = [];
  }
  private getEvaluateOrder() {
    var map: any = {};
    map.company_id = UserModule.getCompanyId;
    map.user_id = UserModule.getUserId;
    map.order_id = this.orderId;
    getEvaluateOrder(map)
      .then(res => {
        if (res.data) {
          let resData = res.data;
          this.evaluateTags = resData.evaluate_tags_list;
          if (resData.order_task_engineer_list.length > 0) {
            for (var i = 0; i < resData.order_task_engineer_list.length; i++) {
              resData.order_task_engineer_list[i].selectTags = [];
              if (!this.orderTaskList) {
                this.orderTaskList = [];
              }
              resData.order_task_engineer_list[i].score_num = 5;
              this.orderTaskList.push(resData.order_task_engineer_list[i]);
            }
          }
          if (resData.order_task_dept_list.length > 0) {
            for (var m = 0; m < resData.order_task_dept_list.length; m++) {
              resData.order_task_dept_list[m].loc_type = 1;
              resData.order_task_dept_list[m].selectTags = [];
              if (!this.orderTaskList) {
                this.orderTaskList = [];
              }
              resData.order_task_dept_list[m].score_num = 5;
              this.orderTaskList.push(resData.order_task_dept_list[m]);
            }
          }
          if (resData.order_task_company_list && resData.order_task_company_list.length > 0) {
            for (var j = 0; j < resData.order_task_company_list.length; j++) {
              var temp:any = {};
              temp.loc_type = 2;
              temp.selectTags = [];
              if (resData.order_task_company_list[j].main_company_name) {
                temp.servicer_company_id = resData.order_task_company_list[j].main_company_id;
                temp.servicer_company_name = resData.order_task_company_list[j].main_company_name;
              } else {
                temp.servicer_company_id = resData.order_task_company_list[j].company_id;
                temp.servicer_company_name = resData.order_task_company_list[j].company_name;
              }
              if (!this.orderTaskList) {
                this.orderTaskList = [];
              }
              temp.score_num = 5;
              this.orderTaskList.push(temp);
            }
          }
        }
      })
      .catch(error => {
        let msg = error.msg;
      });
  }
  private getTags(level:number, type:number) {
    if (this.evaluateTags && this.evaluateTags.length > 0) {
      let tags = [];
      for (var item of this.evaluateTags) {
        if (parseInt((item as any).level) === level) {
          if (type === 1 || type === 2) {
            tags = (item as any).dept_company_tags_list;
          } else {
            tags = (item as any).engineer_tags_list;
          }
          return tags;
        }
      }
    }
    return [];
  }
  private dealData(data:any) {
    var arr = [];
    for (var i = 0; i < data.length; i++) {
      let tagStr = '';
      let tagIdStr = '';
      if (data[i].selectTags && data[i].selectTags.length > 0) {
        let labArr = data[i].selectTags;
        for (var k = 0; k < labArr.length; k++) {
          tagStr = tagStr + labArr[k].name + ',';
          tagIdStr = tagIdStr + labArr[k].id + ',';
        }
      }
      var evaluatedBean:any = {};
      if (data[i].id) {
        evaluatedBean.company_id = data[i].company_id;
        evaluatedBean.task_id = data[i].id;
        if (data[i].loc_type === 1) {
          evaluatedBean.dept_id = data[i].dept_id;
          evaluatedBean.dept_name = data[i].dept_name;
        } else {
          evaluatedBean.user_id = data[i].user_id;
          evaluatedBean.user_name = data[i].user_name;
        }

        evaluatedBean.tags_id = tagIdStr.substring(0, tagIdStr.length - 1);
        if (!data[i].loc_remark) {
          evaluatedBean.detail = tagStr.substring(0, tagStr.length - 1);
        } else {
          evaluatedBean.detail = data[i].loc_remark + tagStr.substring(0, tagStr.length - 1);
        }
        if (!data[i].score_num) {
          evaluatedBean.score = 0;
        } else {
          evaluatedBean.score = data[i].score_num;
        }
        arr.push(evaluatedBean);
      } else {
        evaluatedBean.company_id = data[i].servicer_company_id;
        evaluatedBean.company_name = data[i].servicer_company_name;
        evaluatedBean.tags_id = tagIdStr.substring(0, tagIdStr.length - 1);
        if (!data[i].loc_remark) {
          evaluatedBean.detail = tagStr.substring(0, tagStr.length - 1);
        } else {
          evaluatedBean.detail = data[i].loc_remark + tagStr.substring(0, tagStr.length - 1);
        }
        if (!data[i].score_num) {
          evaluatedBean.score = 0;
        } else {
          evaluatedBean.score = data[i].score_num;
        }
        arr.push(evaluatedBean);
      }
    }

    return JSON.stringify(arr);
  }
  private evaluateOrder() {
    var map:any = {};
    map.company_id = UserModule.getCompanyId;
    map.user_id = UserModule.getUserId;
    map.user_name = UserModule.getUserName;
    map.order_id = this.orderId;
    map.order_task = this.dealData(this.orderTaskList);
    evaluateOrder(map).then(data => {
      // 标记列表需要刷新
      this.$store.dispatch('CloseEvaluated', true);
      this.$router.go(-1);
    }).catch(error => {
      let msg = error.msg;
    });
  }
}
